var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiBaseIcon',{attrs:{"width":"12","height":"12","color":_vm.color,"icon-name":"filterColumn"}})}
var staticRenderFns = []

export { render, staticRenderFns }